export default (categorySlug, slug) => `/${slug}/category/${categorySlug}`;
